import React, { useState, useEffect } from "react";
import { Row, Col, FormGroup, Label, UncontrolledTooltip } from "reactstrap";

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";

const CustomSelectMulti = ({
  t,
  objItems,
  name,
  id,
  title,
  isRequired,
  isLoading,
  placeholder,
  onChange,
  value,
}) => {
  const [Entity, setEntity] = useState();
  const [Permissions, setPermissions] = useState();
  const [keysEntity, setKeyEntity] = useState();

  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [isOnFocus, setIsOnFocus] = useState(false);
  const [error, setError] = useState(false);

  const [newRolesValues, setNewRolesValues] = useState({
    options: [],
  });

  const getSelectedOptValues = () => {
    let selectedOptValues = [];
    if (
      newRolesValues &&
      newRolesValues.options &&
      newRolesValues.options[0] !== null
    ) {
      let optInserted = newRolesValues.options.map(
        (item) => JSON.parse(item.value).permissions
      );

      optInserted.forEach((item1) => {
        item1.forEach((item2) => {
          selectedOptValues.push(item2.value);
        });
      });
    }
    return selectedOptValues;
  };

  const isEntityFullSelected = (entity) => {
    let notSelected = 0;
    let selectedOptValues = getSelectedOptValues();

    if (objItems && objItems[entity]) {
      objItems[entity].map(
        (item) => !selectedOptValues.includes(item.id) && notSelected++
      );
      if (notSelected === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const isEntityInserted = (enti) => {
    let isInserted = false;
    if (newRolesValues.options[0]) {
      let parseOpt = newRolesValues.options.map((item) => ({
        key: item.key,
        value: JSON.parse(item.value),
        label: item.label,
      }));
      parseOpt.forEach((item) => {
        if (item.value.entity === enti.value) {
          isInserted = true;
        }
      });
      return isInserted;
    }
    return isInserted;
  };

  const optEntity = (objItems, isSetKey) => {
    let opt = [];

    if (objItems) {
      Object.keys(objItems).map(
        (item, key) =>
          !isEntityFullSelected(item) &&
          opt.push({
            key: key,
            value: item,
            label: item.charAt(0).toUpperCase() + item.slice(1),
          })
      );
    } else {
      opt.push({
        value: "empty",
        label: t("No matching records found"),
        isDisabled: true,
      });
    }
    if (isSetKey) {
      setKeyEntity(opt);
    }
    return opt;
  };

  const optPermissions = (objItems) => {
    let opt = [];
    let selectedOptValues = getSelectedOptValues();

    if (Entity && Entity.value && objItems[Entity.value]) {
      objItems[Entity.value].map(
        (item, key) =>
          !selectedOptValues.includes(item.id) &&
          opt.push({
            key: key,
            value: item.id,
            action: item.action,
            description: item.description,
            label: item.action.toUpperCase() + " | " + item.description,
          })
      );
    } else {
      opt.push({
        value: "empty",
        label: t("No matching records found"),
        isDisabled: true,
      });
    }
    return opt;
  };

  const stringfyPermission = (permissionValue) => {
    return permissionValue.map((item) => ({
      key: item.key,
      value: JSON.stringify(item.value),
      label: item.label,
    }));
  };

  const parsePermission = (permissionValue) => {
    return permissionValue.options.map((item) => ({
      key: item.key,
      value: JSON.parse(item.value),
      label: item.label,
    }));
  };

  const sortActions = (x) => {
    if (x.indexOf("GET") > -1) return 0;
    if (x.indexOf("POST") > -1) return 1;
    if (x.indexOf("PUT") > -1) return 2;
    if (x.indexOf("ACTIVATE") > -1) return 3;
    if (x.indexOf("DELETE") > -1) return 4;
    return 5; // Unknown
  };

  const setLabel = (entityItem, permissionsItem) => {
    let entity =
      entityItem.value.charAt(0).toUpperCase() + entityItem.value.slice(1);

    let sortedPermissions = permissionsItem
      .map((item) => item.action.toUpperCase())
      .sort((a, b) => {
        var result = sortActions(a) - sortActions(b);
        if (result === 0) result = a.localeCompare(b);
        return result;
      });
    let permissions = sortedPermissions.map((item, key) =>
      item === "GET" ? (
        <span key={key} className="permission-badge get">
          {item + " "}
        </span>
      ) : item === "POST" ? (
        <span key={key} className="permission-badge post">
          {item + " "}
        </span>
      ) : item === "PUT" ? (
        <span key={key} className="permission-badge put">
          {item + " "}
        </span>
      ) : item === "ACTIVATE" ? (
        <span key={key} className="permission-badge activate">
          {item + " "}
        </span>
      ) : item === "DELETE" ? (
        <span key={key} className="permission-badge delete">
          {item + " "}
        </span>
      ) : (
        <span key={key} className="permission-badge">
          {item + " "}
        </span>
      )
    );

    return (
      <span>
        {entity} | <span>{permissions}</span>
      </span>
    );
  };

  const setBadge = (entityItem, permissionsItem, stringfy) => {
    let key = entityItem.key;
    let entity = entityItem.value;
    let permissions = permissionsItem.map((item) => ({
      value: item.value,
      action: item.action,
      description: item.description,
    }));
    let lab = setLabel(entityItem, permissionsItem);
    return {
      key: key,
      value: stringfy
        ? JSON.stringify({
            entity: entity,
            permissions: permissions,
          })
        : {
            entity: entity,
            permissions: permissions,
          },
      label: lab,
    };
  };

  const setOptToValue = (value) => {
    let aux = [];
    Object.keys(value).map((entityItem) =>
      aux.push(
        setBadge(
          {
            key: keysEntity.find((item) => item.value === entityItem)?.key,
            value: entityItem,
          },
          value[entityItem].map((item) => ({
            value: item.id,
            action: item.action,
            description: item.description,
          })),
          true
        )
      )
    );
    return aux;
  };

  const insertRole = (
    Entity,
    Permissions,
    newRolesValues,
    isEntityInserted,
    parsePermission,
    setBadge,
    stringfyPermission,
    setNewRolesValues,
    onChange,
    cleanFields,
    setError
  ) => {
    if (Entity && Permissions && Permissions.length > 0) {
      if (newRolesValues.options.length > 0) {
        if (isEntityInserted(Entity)) {
          let parsedOpt = parsePermission(newRolesValues);

          let permissionInserted =
            parsedOpt[
              parsedOpt.findIndex((item) => item.value.entity === Entity.value)
            ];

          let permissionsAux = permissionInserted.value.permissions.concat(
            Permissions
          );
          let newRoleItem = setBadge(Entity, permissionsAux);

          parsedOpt[
            parsedOpt.findIndex((item) => item.value.entity === Entity.value)
          ] = newRoleItem;

          let aux = stringfyPermission(parsedOpt);

          setNewRolesValues((previous) => ({
            ...previous,
            options: aux,
          }));
          onChange({ options: aux });
        } else {
          let newRoleItem = setBadge(Entity, Permissions, true);

          let aux = newRolesValues.options;

          aux.push(newRoleItem);
          setNewRolesValues((previous) => ({
            ...previous,
            options: aux,
          }));
          onChange({ options: aux });
        }
      } else {
        let newRoleItem = setBadge(Entity, Permissions, true);
        setNewRolesValues({
          options: [newRoleItem],
        });
        onChange({ options: [newRoleItem] });
      }

      cleanFields();
      setIsOnFocus(true);
      //setMenuIsOpen(false);
    } else {
      setError(true);
    }
  };

  const onEnterEscape = (e) => {
    if (e.key === "Enter") {
      insertRole(
        Entity,
        Permissions,
        newRolesValues,
        isEntityInserted,
        parsePermission,
        setBadge,
        stringfyPermission,
        setNewRolesValues,
        onChange,
        cleanFields,
        setError
      );
    }
    if (e.key === "Escape") {
      cleanFields();
      setMenuIsOpen(false);
    }
  };

  const content = () => {
    return (
      <div className="bg-light py-3">
        <Row className="mx-2 justify-content-between">
          <Col sm="12" lg="4" className="px-1">
            <FormGroup className="select2-container">
              <Label>{t("Entity")}</Label>
              <Select
                id="entity"
                name="entity"
                classNamePrefix="select2-selection"
                placeholder={t("Choose") + "..."}
                options={optEntity(objItems)}
                openMenuOnClick={true}
                onChange={(e) => {
                  cleanFields();
                  setEntity(e);
                }}
                value={Entity}
                onFocus={isOnFocus}
                onBlur={() => setIsOnFocus(false)}
              />
            </FormGroup>
          </Col>
          <Col sm="12" lg="6" className="px-1">
            <FormGroup className="select2-container">
              <Label>{t("Permissions")}</Label>
              <Select
                id="permissions"
                name="permissions"
                classNamePrefix="select2-selection"
                placeholder={t("Choose") + "..."}
                options={optPermissions(objItems)}
                onChange={(e) => {
                  setPermissions(e);
                }}
                value={Permissions}
                isMulti
                isDisabled={Entity ? false : true}
              />
            </FormGroup>
          </Col>
          <Col sm="12" lg="1" className="px-1 my-auto text-center">
            <div>
              <i
                id="entertooltip"
                className="bx bxs-plus-circle w-50 text-success"
                style={{ fontSize: "2.5em", cursor: "pointer" }}
                onClick={() => {
                  insertRole(
                    Entity,
                    Permissions,
                    newRolesValues,
                    isEntityInserted,
                    parsePermission,
                    setBadge,
                    stringfyPermission,
                    setNewRolesValues,
                    onChange,
                    cleanFields,
                    setError
                  );
                }}
              />
              <UncontrolledTooltip placement="top" target="entertooltip">
                {t("Add/Press Enter")}
              </UncontrolledTooltip>
            </div>
          </Col>
          <Col sm="12" lg="1" className="px-1 my-auto text-center">
            <div>
              <i
                id="esctooltip"
                className="mdi mdi-window-close w-50 text-secondary"
                style={{ fontSize: "2.5em", cursor: "pointer" }}
                onClick={() => {
                  cleanFields();
                  setMenuIsOpen(false);
                }}
              />
              <UncontrolledTooltip placement="top" target="esctooltip">
                {t("Exit/Press Esc")}
              </UncontrolledTooltip>
            </div>
          </Col>
        </Row>
        <Col className="py-1 my-auto text-danger text-center">
          {error && "Por favor preencha todos os campos"}
        </Col>
      </div>
    );
  };

  const optSelect = () => {
    let options = [{ value: 1, label: content(), isDisabled: true }];
    return options;
  };

  const cleanFields = () => {
    setEntity(null);
    setPermissions(null);
  };

  const customStyles = {
    option: () => ({}),
    dropdownIndicator: () => ({ display: "none" }),
    menuList: () => ({
      padding: "0",
    }),
  };

  useEffect(() => {
    if (error)
      setTimeout(() => {
        setError(false);
      }, 2000);
  }, [error]);

  useEffect(() => {
    let permissions = optPermissions(objItems);
    if (permissions[0].value !== "empty") {
      setPermissions(permissions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Entity]);

  useEffect(() => {
    optEntity(objItems, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objItems]);

  useEffect(() => {
    let aux = setOptToValue(value);
    setNewRolesValues((previous) => ({
      ...previous,
      options: aux,
    }));
    onChange({ options: aux });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <React.Fragment>
      <FormGroup className="select2-container">
        <Label className="control-label">{title}</Label>
        <Select
          classNamePrefix="select2-selection"
          className="customSelectMulti"
          id={id}
          name={name}
          isLoading={isLoading}
          placeholder={
            isLoading
              ? `${t("Loading")} ...`
              : objItems
              ? placeholder
              : t("No matching records found")
          }
          isDisabled={objItems ? false : true}
          isClearable={false}
          options={optSelect()}
          onChange={(e, selected) => {
            if (selected.action === "remove-value") {
              let aux = e !== null ? e : [];
              setNewRolesValues((previous) => ({
                ...previous,
                options: aux,
              }));
              onChange({ options: aux });
            }
          }}
          required={isRequired}
          isMulti
          styles={customStyles}
          menuIsOpen={menuIsOpen}
          onMenuOpen={() => setMenuIsOpen(true)}
          value={newRolesValues.options}
          onKeyDown={(e) => onEnterEscape(e)}
        />
      </FormGroup>
    </React.Fragment>
  );
};

export default withTranslation()(CustomSelectMulti);
